import {fetch} from "utils/dataAccess";

export default async function getLastImportReport(feedId) {
    const response = await fetch(`/import_reports?feed.id=${feedId}&order[createdAt]=desc&itemsPerPage=1`);

    return (await response.json())['hydra:member'][0];
}
